<template>
  <div class="moduleStyle minHeight">
    <el-tabs
      v-model="activeTab"
      @tab-click="handleTabChange"
      style="margin-left: 20px"
    >
      <el-tab-pane label="汇总分析" name="summary">
        <basicList
          v-if="activeTab === 'summary'"
          :config="basicListconfig"
          @sortChange="sortChange"
          @search="searchEvent"
        >
          <template v-slot:avg_def_money="row">
            <template v-if="row.row.avg_def_money <= 0">
              <el-link type="danger">{{
                row.row.avg_def_money | money
              }}</el-link>
            </template>
            <template v-else>
              <el-link type="success">{{
                row.row.avg_def_money | money
              }}</el-link>
            </template>
          </template>

          <template v-slot:def_money="row">
            <template v-if="row.row.def_money <= 0">
              <el-link type="danger">{{ row.row.def_money | money }}</el-link>
            </template>
            <template v-else>
              <el-link type="success">{{ row.row.def_money | money }}</el-link>
            </template>
          </template>
          <template v-slot:additionalFeatures>
            <div class="procurementDataSummary procurementDataSummary2">
              <ul>
                <li>
                  <div>
                    <div class="summaryTitle">外卖单数</div>
                    <div class="today summaryLine">
                      <p>{{ summarizeData.count1 }}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="summaryTitle">订单金额</div>
                    <div class="yesterday summaryLine">
                      <p>¥{{ summarizeData.totalmoney | money }}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="summaryTitle">外卖毛利</div>
                    <div class="summaryLine">
                      <p>¥{{ summarizeData.totaldef_money | money }}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="summaryTitle">运费金额</div>
                    <div class="summaryLine">
                      <p>¥{{ summarizeData.flowmoney | money }}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="summaryTitle">平均运费</div>
                    <div class="summaryLine">
                      <p>
                        ¥{{ summarizeData.avg_flowmoney | money
                        }}<span style="font-size: 14px"> / 单</span>
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="summaryTitle">外卖净利</div>
                    <div class="summaryLine">
                      <p>¥{{ summarizeData.def_flowmoney | money }}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div style="height: 20px"></div>
          </template>
        </basicList>
      </el-tab-pane>
      <el-tab-pane label="详情分析" name="details">
        <div
          style="
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 10px;
            margin-right: 50px;
          "
        >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="exportDetail"
          >
            导出
          </el-button>
        </div>
        <basicList
          v-if="activeTab === 'details'"
          :config="detailListConfig"
          @sortChange="detailSortChange"
          @search="detailSearchEvent"
        >
          <template v-slot:form_sn="row">
            <el-link type="primary" @click="purchaseOrder(row.row)">{{
              row.row.form_sn
            }}</el-link>
          </template>

          <template v-slot:price_diff="row">
            <template v-if="row.row.price_diff <= 0">
              <el-link type="danger">{{ row.row.price_diff | money }}</el-link>
            </template>
            <template v-else>
              <el-link type="success">{{ row.row.price_diff | money }}</el-link>
            </template>
          </template>

          <template v-slot:def_money="row">
            <template v-if="row.row.def_money <= 0">
              <el-link type="danger">{{ row.row.def_money | money }}</el-link>
            </template>
            <template v-else>
              <el-link type="success">{{ row.row.def_money | money }}</el-link>
            </template>
          </template>

          <template v-slot:order_real_profit_money="row">
            <template v-if="row.row.order_real_profit_money <= 0">
              <el-link type="danger">{{
                row.row.order_real_profit_money | money
              }}</el-link>
            </template>
            <template v-else>
              <el-link type="success">{{
                row.row.order_real_profit_money | money
              }}</el-link>
            </template>
          </template>
        </basicList>
      </el-tab-pane>
    </el-tabs>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
  </div>
</template>

<script>
import axios from "axios";
import { getSession } from "@/utils/cookie";
import { gettakeoutlist, getdetailList } from "@/api/report";
import { itemClassGetList, getshoplist } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import { orderBuyGetOne, orderMoveDetail } from "@/api/purchasing";
import { orderSellGetOne } from "@/api/sale";

const defaultParameters = {
  page: 1,
  limit: 10,
};

export default {
  name: "takeoutAnalysis",
  components: {
    previewComponents: () => import("@/components/previewComponents"),
  },
  data() {
    return {
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      activeTab: "summary", // 当前激活的标签
      // 汇总分析配置
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "平台",
            type: "select",
            options: [
              { label: "美团", value: 7 },
              { label: "饿百", value: 8 },
              { label: "京东", value: 9 },
            ],
            key: "order_type",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          {
            label: "品名",
            prop: "name",
            sortable: true,
            width: 250,
            fixed: "left",
          },
          { label: "分类", prop: "stock_class_name", width: 250 },
          { label: "门店", prop: "shopname", width: 180 },
          { label: "订单数", prop: "countorder", sortable: true, width: 180 },
          { label: "销售总量", prop: "num", sortable: true, width: 200 },
          {
            label: "销售均价",
            prop: "avg_price",
            isMoney: true,
            sortable: true,
            width: 200,
          },
          {
            label: "销售总额",
            prop: "total_money",
            isMoney: true,
            sortable: true,
            width: 200,
          },
          {
            label: "平均毛利",
            prop: "avg_def_money",
            isMoney: true,
            sortable: true,
            width: 200,
            slot: true,
          },
          {
            label: "销售总毛利",
            prop: "def_money",
            isMoney: true,
            sortable: true,
            width: 200,
            slot: true,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      // 详情分析配置
      detailListConfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "平台",
            type: "select",
            options: [
              { label: "美团", value: 7 },
              { label: "饿百", value: 8 },
              { label: "京东", value: 9 },
            ],
            key: "order_type",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          { label: "门店", prop: "shopname", width: 80 },
          { label: "平台", prop: "platform", width: 80 },
          { label: "品名", prop: "item_name", width: 200 },
          {
            label: "售价",
            prop: "price_distribution",
            width: 80,
            isMoney: true,
          },
          { label: "成本", prop: "avg_price", width: 80, isMoney: true },
          {
            label: "价差",
            prop: "price_diff",
            width: 80,
            sortable: true,
            isMoney: true,
            slot: true,
          },
          { label: "数量", prop: "num", sortable: true, width: 80 },
          {
            label: "小计",
            prop: "total_money",
            sortable: true,
            width: 80,
            isMoney: true,
          },
          {
            label: "毛利",
            prop: "def_money",
            sortable: true,
            width: 80,
            isMoney: true,
            slot: true,
          },
          {
            label: "订单金额",
            prop: "order_total_money",
            sortable: true,
            width: 110,
            isMoney: true,
          },
          {
            label: "订单毛利",
            prop: "order_real_profit_money",
            sortable: true,
            width: 110,
            isMoney: true,
            slot: true,
          },
          { label: "订单号", prop: "form_sn", width: 200, slot: true },
          { label: "外卖号", prop: "order_sn", width: 200 },
          { label: "时间", prop: "create_time", width: 160, sortable: true },
          { label: "条码", prop: "item_number", width: 140 },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      summarizeData: {
        count: 0,
        count1: 0,
        totalmoney: 0,
        totaldef_money: 0,
        flowmoney: 0,
        def_flowmoney: 0,
        avg_flowmoney: 0,
      },
    };
  },
  created() {
    this.obtainDataSource();
    this.searchEvent({
      shop_id: JSON.parse(getRoles()).shop_id,
    });
  },
  methods: {
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    refresh() {
      this.preview(this.temporaryRowData);
    },
    purchaseOrder(row) {
      console.log(
        "%c [ row ]-314",
        "font-size:13px; background:pink; color:#bf2c9f;",
        row
      );
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      if (row.form_sn.includes("XS")) {
        orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.freeze_num = item.item_info.freeze_num;
              item.price_distribution = this.$money(item.price_distribution);
              item.item_stock_single = item.item_info.item_stock_single;
              item.item_stock_package = item.item_info.item_stock_package;
              item.total_money = this.$money(item.total_money);
              item.def_money = this.$money(item.def_money);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.single_num +
                "+" +
                item.package_num +
                "*" +
                item.item_info.in_package_num +
                ")" +
                "=" +
                item.total_money;
              item.total = item.num;
              //   Number(item.single_num) +
              //   Number(item.package_num) * Number(item.item_info.in_package_num);
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "客户",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "销售门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "业务员",
                    value: res.order_info.customer_user_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                ],
              },
              {
                title: "销售明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                    width: "500px",
                  },
                  {
                    label: "销售单价",
                    prop: "price_distribution",
                  },

                  {
                    label: "销售总量",
                    prop: "total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "single_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "package_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计金额",
                    prop: "total_money",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "金额",
                    //     prop: "total_money",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "算法",
                    //     prop: "algorithm",
                    //     width: 200,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "商品毛利",
                    prop: "def_money",
                    align: "center",
                  },
                ],
              },
              {
                title: "销售金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费收入",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "总数量",
                    value: res.order_info.num,
                  },
                  {
                    label: "运费支出",
                    value: this.$money(res.order_info.trans_money_self),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "净毛利",
                    value: this.$money(
                      Number(res.order_info.real_profit_money)
                    ),
                  },
                  {
                    label: "应收总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "收款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "收款账户",
                    prop: "account_name",
                  },
                  {
                    label: "收款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "收款信息",
                type: "object",
                value: [
                  {
                    label: "已收金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未收金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "订单备注",
                type: "object",
                value: [
                  {
                    label: "公司名称",
                    value: res.order_info.comp_remark,
                  },
                  {
                    label: "其它备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "customer_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
            this.previewParams.type = "sale";
          } else {
            this.$message.error("获取详情失败");
          }
        });
      } else {
        orderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")";
              item.price_distribution = this.$money(item.price_distribution);
              item.need_item_stock_single = item.single_num;
              item.need_item_stock_package = item.package_num;
              item.total_money = this.$money(item.total_money);
              item.price_oneBox = (
                Number(item.price_distribution) * Number(item.in_package_num)
              ).toFixed(2);
              item.need_item_stock_total = (
                Number(item.need_item_stock_single) +
                Number(item.need_item_stock_package) *
                  Number(item.in_package_num)
              ).toFixed(0);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.need_item_stock_single +
                "+" +
                item.need_item_stock_package +
                "*" +
                item.in_package_num +
                ") = " +
                item.total_money;
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "供应商",
                    value: res.order_info.supplier_name,
                  },
                  {
                    label: "采购门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "采购人",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                  {
                    label: "备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "采购明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                  },
                  {
                    label: "单价",
                    prop: "price_distribution",
                  },
                  {
                    label: "采购数量",
                    prop: "num",
                    align: "center",
                  },
                  {
                    label: "小计",
                    prop: "total_money",
                    width: 200,
                  },
                ],
              },
              {
                title: "采购金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费金额",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "应付总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "付款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "付款账户",
                    prop: "account_name",
                  },
                  {
                    label: "付款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "已付金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未付金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
    },
    handleTabChange(tab) {
      if (tab.name === "details") {
        this.detailSearchEvent({
          shop_id: JSON.parse(getRoles()).shop_id,
        });
      }
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order === "ascending" ? 1 : data.order === "descending" ? 0 : "";
      this.getData();
    },
    detailSortChange(data) {
      this.detailListConfig.searchParameters.page = 1;
      this.detailListConfig.searchParameters.order_column = data.prop;
      this.detailListConfig.searchParameters.order_up =
        data.order === "ascending" ? 1 : data.order === "descending" ? 0 : "";
      this.getDetailData();
    },
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getData();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key === "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getData();
      }
    },
    detailSearchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.detailListConfig.page = page;
        if (pageSize) this.detailListConfig.searchParameters.limit = pageSize;
        this.getDetailData();
      } else if (data) {
        for (const key in data) {
          this.detailListConfig.searchParameters[key] = data[key];
          if (key === "time") {
            this.detailListConfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.detailListConfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.detailListConfig.searchParameters.page = 1;
        this.getDetailData();
      }
    },
    getData() {
      this.basicListconfig.loading = true;
      gettakeoutlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code === 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list;
          for (const key in this.summarizeData) {
            this.summarizeData[key] = res[key];
          }
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    getDetailData() {
      this.detailListConfig.loading = true;
      getdetailList(this.detailListConfig.searchParameters).then((res) => {
        if (res.code === 1) {
          this.detailListConfig.loading = false;
          this.detailListConfig.total = Number(res.count);
          this.detailListConfig.data = res.list;
        } else {
          this.detailListConfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 导出详情文件
    exportDetail() {
      let headers = {
        "x-token": getSession(),
      };

      let downloadUrl =
        (process.env.NODE_ENV === "production"
          ? "https://erp.zuizhenshi.cn"
          : "https://erp.zuizhenshi.cn") +
        "/admin/Report_list/exportTakeOutDetailListExcel";

      let url = downloadUrl;
      let export_params = this.detailListConfig.searchParameters;
      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        params: export_params,
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实-外卖详情-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },

    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code === 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key === "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code === 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key === "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
            this.detailListConfig.search.map((item) => {
              if (item.key === "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/takeoutanalysis/index.vue